const GRID_SIZE = 5;

const NUMBER_OF_GRID_COLS_PER_COLUMN = 16;
const NUMBER_OF_GRID_COLS_PER_GUTTER = 12;

const MAX_NUMBER_OF_COLUMNS = 8;
const COLUMN_WIDTH = GRID_SIZE * NUMBER_OF_GRID_COLS_PER_COLUMN;

const GUTTER_WIDTH = GRID_SIZE * NUMBER_OF_GRID_COLS_PER_GUTTER;
const GUTTER_HEIGHT = 20;

const _calculateColumnWith = numCols => numCols * COLUMN_WIDTH + (numCols - 1) * GUTTER_WIDTH;

const calculateColumnWidth = numCols =>
  _calculateColumnWith(Math.min(numCols, MAX_NUMBER_OF_COLUMNS));

const calculateColumnOffset = numCols =>
  calculateColumnWidth(Math.min(numCols, MAX_NUMBER_OF_COLUMNS - 1)) + GUTTER_WIDTH;

const MAX_WIDTH = calculateColumnWidth(MAX_NUMBER_OF_COLUMNS);

export default {
  MAX_NUMBER_OF_COLUMNS,
  COLUMN_WIDTH,
  GUTTER_WIDTH,
  GUTTER_HEIGHT,
  MAX_WIDTH,
  calculateColumnWidth,
  calculateColumnOffset,
};
